import { ReactElement, useCallback } from 'react';
import { App, Form } from 'antd';
import { styled } from 'styled-components';
import { UpdateCustomerBody } from '@minutes-system/backend/src/api/customers/schema';
import { useNavigate, useParams } from 'react-router-dom';
import useCustomerDetail from '../hooks/useCustomerDetail';
import Buttons from './content/Buttons';
import { blockStyle } from '../../../../components/styles/Block';
import Fields from './content/Fields';

const ContentBlock = styled.article`
  ${blockStyle}
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const FormCard = styled.div`
  width: 320px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
`;

interface CustomerFormValue {
  name: string;
  phone: string;
  mobilePhone: string;
}

const Content = (): ReactElement => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const customerId = Number(id);
  const [form] = Form.useForm<CustomerFormValue>();
  const { message } = App.useApp();
  const { customer, updateCustomer } = useCustomerDetail(customerId);

  const handleCancel = useCallback(() => {
    void navigate('/customers');
  }, [navigate]);

  const onFinish = useCallback(
    async (values: CustomerFormValue) => {
      try {
        const body: UpdateCustomerBody = {
          name: values.name.trim(),
          phone: values.phone !== '' ? values.phone : null,
          mobilePhone: values.mobilePhone !== '' ? values.mobilePhone : null,
        };

        if (body.name === customer.name && body.phone === customer.phone && body.mobilePhone === customer.mobilePhone) {
          return;
        }

        const result = await updateCustomer(body);
        if (result.success) {
          message.success('顧客情報を更新しました');
          void navigate('/customers');
        }
      } catch (error) {
        console.error('Failed to update customer:', error);
        message.error('顧客情報の更新に失敗しました');
      }
    },
    [updateCustomer, message, customer, navigate]
  );

  return (
    <ContentBlock>
      <FormCard>
        <Form<CustomerFormValue>
          form={form}
          layout='vertical'
          onFinish={values => {
            void onFinish(values);
          }}
          initialValues={{
            name: customer.name,
            phone: customer.phone ?? '',
            mobilePhone: customer.mobilePhone ?? '',
          }}
        >
          <Fields />
          <Buttons onCancel={handleCancel} />
        </Form>
      </FormCard>
    </ContentBlock>
  );
};

export default Content;
